import { render, staticRenderFns } from "./HistoricoAlteracoes.vue?vue&type=template&id=7aecf49a&scoped=true&"
import script from "./HistoricoAlteracoes.vue?vue&type=script&lang=js&"
export * from "./HistoricoAlteracoes.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAlteracoes.vue?vue&type=style&index=0&id=7aecf49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aecf49a",
  null
  
)

export default component.exports